module.exports = {"341822100":"桃州镇","341822101":"柏垫镇","341822102":"誓节镇","341822103":"邱村镇","341822104":"新杭镇","341822105":"杨滩镇","341822200":"卢村乡","341822201":"东亭乡","341822203":"四合乡","341822500":"祠山岗茶场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341822.json
// module id = 1060
// module chunks = 0